import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { Subtext } from '@scp/ui-shared/components/typography';
var FieldDescriptionText = styled(Subtext).attrs({
  secondary: true,
  as: 'p'
})(_templateObject(), baselineToPx(1));
export function FieldDescription(_ref) {
  var description = _ref.description,
      id = _ref.id;
  return React.createElement(FieldDescriptionText, {
    id: "".concat(id, "-description-text")
  }, description);
}